// sx constants for the summary header strip (SOLD BY CHANNEL / BUY BASED / SOLD BASED / PERFORMANCE)

export const PICTORIAL_SUMMARY_BOX_SX = {
	minWidth: 0,
	width: "100%",
	maxWidth: "100%",
	overflow: "hidden",
	border: "1px solid #e0e0e0",
	borderRadius: 1,
	p: { xs: 0.75, sm: 1 },
	pt: { xs: 0.875, sm: 1 },
	bgcolor: "#fff",
	boxSizing: "border-box",
};

export const PICTORIAL_SUMMARY_HEADER_SX = {
	mb: 0.75,
	pb: 0.5,
	color: "#000",
	fontWeight: "bold",
	fontSize: "0.75rem",
	textAlign: "center",
	borderBottom: "1px solid #eee",
};

export const PICTORIAL_SUMMARY_ROW_SX = {
	mb: 0.5,
	color: "#000",
	display: "grid",
	gridTemplateColumns: "minmax(0, 1fr) auto",
	columnGap: 0.75,
	alignItems: "baseline",
	fontSize: { xs: "0.625rem", sm: "0.6875rem" },
	lineHeight: 1.25,
	"& > *:first-child": {
		minWidth: 0,
		fontWeight: "bold",
	},
	"& > *:last-child": {
		textAlign: "right",
		fontVariantNumeric: "tabular-nums",
		minWidth: 0,
	},
};

export const PICTORIAL_SUMMARY_VALUE_SX = {
	textAlign: "right",
	fontVariantNumeric: "tabular-nums",
	minWidth: 0,
};

export const PICTORIAL_SUMMARY_SUBVALUE_SX = {
	color: "#666",
	fontWeight: 400,
	fontSize: "0.58rem",
	display: "block",
	lineHeight: 1.1,
	textAlign: "right",
};

export const PICTORIAL_CHANNEL_SOLD_GRID_SX = {
	...PICTORIAL_SUMMARY_ROW_SX,
	gridTemplateColumns: "minmax(0, auto) minmax(0, 1fr) minmax(0, 1fr)",
	columnGap: 0.75,
	alignItems: "baseline",
	width: "100%",
};

export const PICTORIAL_CHANNEL_SOLD_VALUE_SX = {
	...PICTORIAL_SUMMARY_VALUE_SX,
	whiteSpace: "nowrap",
};

export const PICTORIAL_SUMMARY_STRIP_GRID_SX = {
	display: "grid",
	width: "100%",
	minWidth: 0,
	gap: 1.25,
	gridTemplateColumns: {
		xs: "1fr",
		sm: "repeat(2, minmax(0, 1fr))",
		md: "repeat(4, minmax(0, 1fr))",
	},
};

export const PICTORIAL_SUMMARY_BAL_SX = PICTORIAL_SUMMARY_SUBVALUE_SX;
